import React from 'react';
export function TopBar() {
  return <>
      {/* Pre-Header Notification Bar */}
      <div className="w-full bg-brand-dark text-white text-center py-2 px-4 text-xs md:text-sm font-medium tracking-wide z-50 relative" data-id="element-354">
        <span className="animate-pulse mr-2" data-id="element-355">🚨</span>
        <span className="font-bold text-brand-light" data-id="element-356">
          OFERTA ESPECIAL POR TIEMPO LIMITADO:
        </span>{' '}
        Acceso inmediato + 6 Tomos + 6 Bonos Exclusivos
      </div>

      {/* Brand Header */}
      <header className="w-full bg-surface-gray/95 backdrop-blur-sm border-b border-brand-light/30 sticky top-0 z-40" data-id="element-357">
        <div className="max-w-5xl mx-auto px-4 h-14 md:h-16 flex items-center justify-center" data-id="element-358">
          <a href="#" className="flex flex-col items-center leading-none no-underline" aria-label="AvanzaPro - Inicio" data-id="element-359">
            <span className="font-montserrat font-black tracking-tight text-brand-dark text-lg md:text-xl" data-id="element-360">
              AVANZA
            </span>
            <span className="font-montserrat font-bold tracking-[0.35em] text-brand-light text-[10px] md:text-xs -mt-0.5 pl-[0.35em]" data-id="element-361">
              PRO
            </span>
          </a>
        </div>
      </header>
    </>;
}